<p-card>
  <ng-template #title>
    <div class="notification-header">
      <h3 class="notification-header__title" [routerLink]="notification?.link" [ngClass]="{ pointer: notification?.link }">
        @if (notification.subject) {
          {{ `${TRANSLOCO_PREFIX}.mentionedIn` | transloco: { notification } }}
        } @else {
          {{ `${TRANSLOCO_PREFIX}.mentionedYou` | transloco: { notification } }}
        }
      </h3>
      <div class="notification-header__actions">
        <eg-icon-button
          egBorderStyle="hidden"
          egButtonSize="small"
          [icon]="`/assets/icons/${notification.task ? 'unbookmark' : 'bookmark'}.svg`"
          [egTooltip]="
            notification.task ? (`${TRANSLOCO_PREFIX}.removeFromTasks` | transloco) : (`${TRANSLOCO_PREFIX}.addToTasks` | transloco)
          "
          position="left"
          (click)="handleTask()"
        ></eg-icon-button>
        <eg-icon-button
          egBorderStyle="hidden"
          egButtonSize="small"
          [icon]="`/assets/icons/${notification.read ? 'unwatch' : 'watch'}.svg`"
          [egTooltip]="
            notification.read ? (`${TRANSLOCO_PREFIX}.markAsUnread` | transloco) : (`${TRANSLOCO_PREFIX}.markAsRead` | transloco)
          "
          position="left"
          (click)="handleRead()"
        ></eg-icon-button>
      </div>
    </div>
  </ng-template>

  <ng-template #content>
    <div
      #contentNotification
      class="notification-content"
      [class.notification-content--clamped]="!expanded"
      [innerHTML]="notification.text | sanitizeHtml"
      (click)="clickNotification.emit($event)"
    ></div>
    @if (isOverflowing) {
      <eg-icon-button
        class="show-more"
        egBorderStyle="hidden"
        egButtonSize="small"
        [icon]="`/assets/icons/arrows/${expanded ? 'up' : 'down'}.svg`"
        [egTooltip]="expanded ? (`${TRANSLOCO_PREFIX}.showLess` | transloco) : (`${TRANSLOCO_PREFIX}.showMore` | transloco)"
        position="top"
        (click)="expanded = !expanded"
      ></eg-icon-button>
    }
  </ng-template>
</p-card>
